<template>
  <v-card>
    <v-card-title style="background-color: rgb(8, 71, 118)">
      <span v-if="inEdit" style="color: white">Uređivanje izdavača</span>
      <span v-else style="color: white">Novi izdavač</span>
      <v-spacer></v-spacer>
      <v-icon color="white" @click="close">mdi-close</v-icon>
    </v-card-title>
    <v-card-text class="mt-8">
      <v-form ref="form">
        <v-text-field
          label="Naziv izdavača*"
          outlined
          dense
          v-model="nazivIzdavaca"
          :rules="[rules.nameRules]"
          required
        >
        </v-text-field>
        <v-autocomplete
          v-model="odabranaDrzava"
          :items="getCountries.data"
          dense
          outlined
          label="Odaberi državu*"
          item-text="naziv"
          return-object
          required
          :search-input="countrySearch"
          :rules="[rules.countryRules]"
        ></v-autocomplete>
      </v-form>
      <hint v-if="!inEdit" :hints="getIzdavaciHints" :isSelectable="isSelectable" v-on:selectItem="selectIzdavac"></hint>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        :disabled="!isValid"
        @click="addPublisher"
        :loading="$wait.is('getIzdavacHint')"
        color="rgb(8, 71, 118)"
        style="color: white"
        class="mr-4 mb-2 mt-n5"
        >Spremi</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import _ from 'lodash'
import { waitFor } from 'vue-wait'
export default {
  props: ["naziv", "selectedCountry", "inEdit", "selectedPublisher", "isSelectable","searchPublisher"],
  computed: {
    ...mapGetters(["getCountries", 'getIzdavaciHints']),
    isValid() {
      return this.naziv && this.selectedCountry;
    },
    nazivIzdavaca: {
      set(value) {
        if (value) {
          this.getHint(this, value)
          this.$emit("setNaziv", value);
        } else {
          this.$emit("setNaziv", null);
        }
      },
      get() {
        return this.naziv;
      },
    },
    odabranaDrzava: {
      set(value) {
        if (value) {
          this.$emit("setDrzava", value);
        } else {
          this.$emit("setDrzava", null);
        }
      },
      get() {
        return this.selectedCountry;
      },
    },
  },
  data() {
    return {
      countrySearch: "",
      rules: {
        nameRules: (v) => !!v || "Naziv izdavača je obavezan!",
        countryRules: (v) => !!v || "Država je obavezna!",
      },
    };
  },

  methods: {
    getHint: _.debounce((self, value) => {
      waitFor("getIzdavacHint", async function () {
        await self.$store.dispatch("getIzdavacHint", {
          page: 1,
          search: value,
        });
      }).apply(self);
    }, 500),
    selectIzdavac(izdavac){
      if(this.isSelectable){
        this.$emit("setCreatedIzdavac", izdavac);
          this.$emit("setNaziv", null);
      this.$refs.form.reset();

      }
    },
    addPublisher() {
      let newPublisher = {
        naziv: this.naziv,
        drzava_id: this.selectedCountry.id,
      };
      this.$store.dispatch("getAllIzdavaci");

      if (this.inEdit) {
        Object.assign(newPublisher, { id: this.selectedPublisher.id });
        this.$store.dispatch("editPublisher", newPublisher).then((res) => {
          if (res) {
            waitFor("publishers", async function() {
              await this.$store.dispatch("getPublishers", {page:1 , search: this.searchPublisher});
            }).apply(this);
            this.close();
          }
        });
      } else {
        this.$store.dispatch("createNewPublisher", newPublisher).then((res) => {
          if (res) {
            this.close();
            this.$emit("setCreatedIzdavac", res);
          }
        });
      }
      this.$refs.form.reset();
    },
    close() {
      this.$refs.form.reset();
      this.$store.commit('SET_IZDAVACI_HINTS', null)
      this.$emit("closeDialog");
    },
  },
};
</script>